import { MenuItemACS, MenuItemAdmin, MenuItemHRM, MenuItemUser } from '@/routes/MenuItem'
import { STORAGE, getLocalStorage, setLocalStorage } from '@/shared/utils/storage'
import { hasPermission } from '@/shared/utils/utils'
import { Layout } from 'antd'
import type React from 'react'
import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { useLocation, useNavigate } from 'react-router-dom'
import BreadcrumbHome from './BreadcrumbHome/BreadcrumbHome'
import HeaderMain from './Header'
import LayoutAdmin from './LayoutAdmin'

const { Content } = Layout
const layoutStyle: React.CSSProperties = {
  overflow: 'hidden',
  display: 'block',
}

interface MainLayoutProps {
  type?: string
  children?: React.ReactNode
}

const MainLayout = ({ type = '', children }: MainLayoutProps) => {
  const [menu, setMenu] = useState<any[]>([])
  const navigate = useNavigate()

  const location = useLocation()
  const selectedKey = [(location.state as any)?.activeMenu || location.pathname]
  const { listTabs } = useSelector((state: any) => state?.appGlobal)
  const isLogin = getLocalStorage(STORAGE.TOKEN)

  const setShowListMenu = (list: any[]): any[] | undefined =>
    list?.length
      ? list
          ?.filter((x: any) => hasPermission(x?.tabid, [...listTabs]))
          .map((i: any) => ({
            ...i,
            children: setShowListMenu(i?.children),
          }))
      : undefined

  const onClickMenu = (menu: any) => {
    setLocalStorage(STORAGE.KEY_MENU_ACTIVE, menu.keyPath)
    if (!menu.key.includes('subkey')) navigate(menu.key)
  }

  // biome-ignore lint/correctness/useExhaustiveDependencies: Hàm setShowListMenu tĩnh và không thay đổi reference
  useEffect(() => {
    if (isLogin) {
      let menu = []
      switch (type) {
        case 'isAdmin':
          menu = setShowListMenu(MenuItemAdmin())
          break
        case 'isUser':
          menu = setShowListMenu(MenuItemUser())
          break
        case 'acs':
          menu = setShowListMenu(MenuItemACS())
          break
        case 'hrm':
          menu = setShowListMenu(MenuItemHRM())
          break
        default:
          menu = []
      }
      setMenu(menu || [])
    }
    // }, [userInfo, listTabs, type])
  }, [type, isLogin])

  return (
    <Layout style={layoutStyle}>
      <HeaderMain />
      <BreadcrumbHome className="breadcrumb-custom" />
      <Layout style={{ background: '#fff' }}>
        <Content className="site-layout-background mt-0" style={{ background: '#fff' }}>
          {menu?.length ? (
            <LayoutAdmin menuAdmin={menu} selectedKey={selectedKey} onClickMenu={onClickMenu}>
              {children}
            </LayoutAdmin>
          ) : (
            children
          )}
        </Content>
      </Layout>
    </Layout>
  )
}

export default MainLayout
